import React from "react";
import Navbar from "../components/common/Navbar";
import PlatformHero from "../components/MainPage/PlatformHero";
import FeatureCards from "../components/MainPage/FeatureCards";
import QuickActions from "../components/MainPage/QuickActions";
import RecentJobs from "../components/MainPage/RecentJobs";
import StatsSection from "../components/MainPage/StatsSection";

const MainPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* 플랫폼 히어로 섹션 */}
      <PlatformHero />
      
      {/* 기능 소개 섹션 */}
      <FeatureCards />
      
      {/* 빠른 시작 섹션 */}
      <QuickActions />
      
      {/* 최신 채용공고 섹션 */}
      <RecentJobs />
      
      {/* 통계 섹션 */}
      <StatsSection />
    </div>
  );
};

export default MainPage;
